'use client';

import { useState } from 'react';
import { ButtonRight } from '@/app_components/icons/buttons/ButtonRight';

export const SearchBar = () => {
  const [value, setValue] = useState('');
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    window.location.href = `https://fortune.com/advanced-search/?query=${encodeURIComponent(value)}`;
  };

  return (
    <div className='mb-8 pl-4 pb-6'>
      {/* TODO: Update this once the Form component is ready to be used */}
      <form
        aria-label='search'
        className='flex items-center justify-center h-12'
        method='get'
        onSubmit={handleSubmit}
      >
        <input
          aria-label='What are you looking for?'
          className='flex w-full border bg-transparent px-3 py-1 transition-colors placeholder:text-secondary focus-visible:outline-none focus-visible:ring-0 disabled:cursor-not-allowed disabled:stroke-secondary focus-visible:stroke-accent h-full rounded-xs typography-level-5 max-w-[calc(-50px+65vw)] sm:w-[calc(-100px+50vw)] sm:left-[33vw]'
          onChange={(e) => setValue(e.target.value)}
          placeholder='What are you looking for?'
          type='text'
          value={value}
        />
        <button
          className='group/button inline-flex uppercase items-center justify-center active:shadow-btn-shadow active:shadow-sm focus-visible:shadow-btn-shadow gap-2 whitespace-nowrap font-medium focus-visible:shadow-sm transition-colors [&_*]:transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:pointer-events-none disabled:opacity-50 cursor-pointer font-graphik-compact text-base bg-inverse hover:bg-inverse-hover text-white focus-visible:ring-btn-primary-50 h-full p-6'
          type='submit'
        >
          <div className='flex items-center'>
            Search
            <ButtonRight className='size-3 ml-2' />
          </div>
        </button>
      </form>
    </div>
  );
};
